export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
      require(`../../../Box_sequences/00_avterracebox/avterracebox${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  designSliderImage: require('../../../product drawing/terracesoundbar/DeskStationeryD_av_terrace.png'),
  designImageList: [
    {
      number: 1,
      side: 'SIDE',
      image: require('../../../parts/deskstationeryD/DeskStationeryD01.png'),
    },
    {
      number: 2,
      side: 'BOTTOM',
      image: require('../../../parts/deskstationeryD/DeskStationeryD02.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/deskstationeryD/DeskStationeryD03.png'),
  cutOutPartsFoldImage: require('../../../parts/deskstationeryD/DeskStationeryD04.png'),
  assembleSequenceImages: Array(27)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/26_DeskStationeryd_sequence/Desk Stationeryd${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),

  completeImage: require('../../../complete/DeskStationeryD.jpg'),
  completeImagePc: require('../../../complete/DeskStationeryD.jpg'),
};
